import { render, staticRenderFns } from "./vFormCODE_SNIPPET.vue?vue&type=template&id=1531db4e&scoped=true&"
import script from "./vFormCODE_SNIPPET.vue?vue&type=script&lang=js&"
export * from "./vFormCODE_SNIPPET.vue?vue&type=script&lang=js&"
import style0 from "./vFormCODE_SNIPPET.vue?vue&type=style&index=0&id=1531db4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1531db4e",
  null
  
)

export default component.exports